import React, { useState, useEffect } from "react";
import "../../../assets/css/addunit.css";
import "../../../assets/css/mainMenu.css";
import edit from "../../../assets/icons/edit.svg";
import close from "../../../assets/icons/close.svg";
import plus1 from "../../../assets/icons/plus1.svg";
import ExcelJS from "exceljs";
import recyclebin from "../../../assets/icons/recycle-bin2.svg";
import ArrowDown from "../../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../../assets/icons2/ArrowUp.svg";
import lucide_download from "../../../assets/icons/lucide_download.svg";
import search2 from "../../../assets/icons/search2.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { hasPermission } from "../../../Services/authUtils";

import { useParams } from "react-router-dom";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import fetchWrapper from "../../../AuthMiddleware/FetchWrapper";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../Components/Pagination/Pagination";

const DynamicTable1 = () => {

  const [excelData, setExcelData] = useState([]);
  const [showPreviewModal, setShowPreviewModal] = useState(false);


  const [errorForUpload, setErrorForUpload] = useState("");

  const [schemaDefinitionId, setSchemaDefinitionId] = useState(null);
  const [focusedEditField, setFocusedEditField] = useState(null);
  const [focusedField, setFocusedField] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const [errors, setErrors] = useState({});

  // const [dynamicColumns, setDynamicColumns] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [rowDataToEdit, setRowDataToEdit] = useState(null);

  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionFetchedDataId, setActionFetchedDataId] = useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "_id",
    order: "asc",
  });

  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);
  const [statusFilter, setStatusFilter] = useState("");

  const [master, setMaster] = useState(null); // State to store master data
  const [masterName, setMasterName] = useState(""); // State to store masterName
  const [masterNamePlural, setMasterNamePlural] = useState("");
  const [masterNameSingular, setMasterNameSingular] = useState("");
  const [parameterName, setParameterName] = useState("");
  const [formData, setFormData] = useState({});
  const { masterId } = useParams();
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [columnValue, setColumnName] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const navigate = useNavigate();





  const updateDynamicColumns = (data) => {
    if (data.length > 0) {
      // const columns = Object.keys(data[0]);
      // setDynamicColumns(columns);
    }
  };
  const resetFormData = () => {
    const initialFormData = {};

    if (master && Array.isArray(master.masterFields) && master.masterFields.length > 0) {
      master.masterFields.forEach((masterField) => {
        initialFormData[masterField.field_name] = "";
      });
    } else {
      console.warn("master.masterFields is empty or not defined.");
    }
    setFormData(initialFormData);
  };

  const handleOpenAddModal = () => {
    resetFormData();
    setShowAddModal(true);
  };

  const handleOpenuploadModal = () => {
    // resetFormData();
    setShowUploadModal(true);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };
  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
  };

  const handleOpenEditModal = (rowData) => {
    setRowDataToEdit(rowData);
    setFormData(rowData); // Ensure formData is set for editing
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setRowDataToEdit(null);
  };

  const handleToggleUserStatus = (dataId, dataStatus) => {
    setActionFetchedDataId(dataId);
    setActionType(dataStatus ? "Inactive" : "Restore");
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/masterfields-delete/${masterId}/${actionFetchedDataId}`;
    try {
      // const data =
      await fetchWrapper(url, {
        method: "POST",
      });
      setLoading(false);
      // Update the status of the masterfield
      const updatedFetchedData = fetchedData.map((fetchedData) =>
        fetchedData._id === actionFetchedDataId
          ? { ...fetchedData, status: actionType === "Inactive" ? false : true }
          : fetchedData
      );
      setFetchedData(updatedFetchedData); // Update the masterfields state
      setConfirmModal(false);
      fetchData();
      toast.success(`Data ${actionType} Successful`);
    }
    catch (error) {
      setLoading(false);
      // Log the full error object for debugging
      console.error("Full error object:", error);
      // Attempt to extract the error message
      let errorMessage;
      if (error?.response) {
        errorMessage = error.response.error || error.response.message;
      } else if (error?.error) {
        errorMessage = error.error;
      } else {
        errorMessage = `Failed to ${actionType} data`;
      }
      console.error("Extracted error message:", errorMessage);
      // Show the error message in the toast
      // if (errorMessage.includes("This Data is already used in an active template and cannot be inactivated")) {
        toast.error(errorMessage); // Backend-provided error message
      // } else {
      //   toast.error(`Failed to ${actionType} data`); // Generic fallback error
      // }
      console.error(`Error ${actionType} action:`, error);
    }
  };


  const handleBulkDelete = async () => {
    setLoading(true);

    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/masterfields-delete/${masterId}/${checkedItems[0]}`;

    try {
      const data = await fetchWrapper(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          docIds: checkedItems,
        }),
      });

      setLoading(false);


      const updatedMasterData = fetchedData.map((masterfield) =>
        checkedItems.includes(masterfield._id)
          ? { ...masterfield, status: false }
          : masterfield
      );

      setFetchedData(updatedMasterData);
      setBulkDeleteModal(false);
      toast.success(`All the selected items are Inactivated`);
      setAllChecked(!checkedItems);
      setCheckedItems([]);
      fetchData();
    } catch (error) {
      setLoading(false);
      // Log the full error object for debugging
      console.error("Full error object:", error);
      // Attempt to extract the error message
      let errorMessage;
      if (error?.response) {
        errorMessage = error.response.error || error.response.message;
      } else if (error?.error) {
        errorMessage = error.error;
      } else {
        errorMessage = `Failed to ${actionType} data`;
      }
      console.error("Extracted error message:", errorMessage);
      // Show the error message in the toast
      if (errorMessage.includes("already used in a template")) {
        toast.error(errorMessage); // Backend-provided error message
      } else {
        toast.error(`Failed to ${actionType} data`); // Generic fallback error
      }
      console.error(`Error ${actionType} action:`, error);
    }
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    try {

      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/masters/${masterId}/add`;

      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      setLoading(false);

      toast.success("Data submit Successful");
      fetchData();
      setErrors([]);
      handleCloseAddModal();
    } catch (error) {
      setLoading(false);
      if (error.response) {
        const errorData = error.response;

        setErrors(errorData.errors || {});

        toast.error(errorData.message || "Error adding data");
      } else {
        toast.error("Error adding data");
      }
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedFile(file); // Store the selected file
  // };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // Define valid file extensions for Excel
    const validExtensions = ['.xls', '.xlsx', '.csv'];

    // Check if the file extension is valid
    const fileExtension = file?.name.split('.').pop().toLowerCase();
    if (file && !validExtensions.includes(`.${fileExtension}`)) {
      // If the file extension is invalid, show a toast error
      toast.error("Upload only Excel files (XLS, XLSX, CSV).");
      setSelectedFile(null); // Clear the selected file
      return; // Exit the function
    }

    // Store the valid selected file
    setSelectedFile(file);
  };

  const previewExcel = async () => {
    if (!selectedFile) {
      toast.error("Please select a file before uploading.");
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();

      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        await workbook.xlsx.load(arrayBuffer);
        const worksheet = workbook.worksheets[0]; // Assuming first sheet

        // Extract data
        const rows = [];
        worksheet.eachRow((row) => {
          const rowValues = row.values.map((cell) => cell?.toString() || "");
          rows.push(rowValues);
        });

        setExcelData(rows); // Store the extracted data
        setShowPreviewModal(true); // Show the preview modal
      };

      reader.readAsArrayBuffer(selectedFile);
    } catch (error) {
      console.error("Error reading Excel file:", error);
      toast.error("Failed to read the file.");
    }
  };
  const downloadExcel = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/download-empty-sheet/${masterId}`;

    try {
      const response = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate,
        true
      ); // Pass rawResponse as true to get the raw response

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob(); // Get the blob from the response
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `master-${masterNamePlural}.xlsx`; // Specify the file name here
      document.body.appendChild(a);
      a.click();
      a.remove();

      setLoading(false);
      toast.success(`Download Excel Successful`);
    } catch (error) {
      setLoading(false);
      console.error(`Error downloading Excel:`, error);
      toast.error(`Failed to download Excel: ${error.message}`);
    }
  };

  const [errorForUplad, setErrorForUplad] = useState("");

  const uploadExcel = async () => {
    if (!selectedFile) {
      toast.error("Please select a file before uploading.");
      setTimeout(() => {
        // return;
      }, 5000); // Wait for 5 seconds
    }

    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/upload-excel/${schemaDefinitionId}`;

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetchWrapper(
        url,
        {
          method: "POST",
          body: formData, // Pass the form data including the file
        },
        navigate,
        true // Pass rawResponse as true to get the raw response
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setLoading(false);
      fetchData();
      setSelectedFile("");
      setExcelData("");
      setShowPreviewModal(false);
      setShowUploadModal(false);
      toast.success("File uploaded successfully!");

      // Optionally, handle the response data, e.g., updating UI or state
    } catch (error) {
      setLoading(false);
      console.error(`Error uploading file:`, error);
      toast.error(`Failed to upload file: ${error.message}`);
      setErrorForUplad(error.message);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleEditInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (!rowDataToEdit || !rowDataToEdit._id) {
      console.error("Invalid row data for editing:", rowDataToEdit);
      setLoading(false); // Reset loading state
      return;
    }

    try {


      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/masters/${masterId}/update/${rowDataToEdit._id}`;

      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      setLoading(false); // Reset loading state

      toast.success("Data update Successful");
      handleCloseEditModal();
      setErrors([]);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        const errorData = error.response;

        setErrors(errorData.errors || {});

        toast.error(errorData.message || "Error updating data");
      } else {
        toast.error("Error updating data");
      }
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
    }
  };

  // Calculate the page numbers to display

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };
  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        fetchedData
          .filter((masterfield) => masterfield.status)
          .map((masterfield) => masterfield._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (masterfieldId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(masterfieldId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== masterfieldId)
        : [...prevCheckedItems, masterfieldId];

      setAllChecked(
        updatedCheckedItems.length ===
        fetchedData.filter((masterfield) => masterfield.status).length
      );
      return updatedCheckedItems;
    });
  };

  const fetchData = async () => {
    setErrors([]);
    try {
      const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/dynamic-data/${masterId}/paginate${queryString}`;



      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      if (data.master && Array.isArray(data.data)) {

        const { master } = data;


        setColumnName(master.masterFields);
        setFetchedData(data.data);


        setColumnData(data.data);
        updateDynamicColumns(data.data);
        setMaster(master);
        setMasterName(master.master_name);
        setMasterNamePlural(master.display_name_plural);
        setMasterNameSingular(master.display_name_singular);
        setParameterName(master.parameter_type_id.parameter_type_name);
        setSchemaDefinitionId(master.schemaDefinitionId);

        // Update pagination states
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
        setTotalItems(data.totalItems);
        setAllChecked(false); // Reset allChecked state
        setCheckedItems([]);
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchData(); // Perform search
    }
  };

  useEffect(() => {


    if (!masterId) {
      console.error("masterId is undefined");
      return;
    }

    fetchData();
  }, [
    // masterId,
    showEditModal,

    page,
    pageSize,
    sortBy.field,
    sortBy.order,
    // search,
    // totalPages,
    // currentPage,
    // totalItems,
    statusFilter,
  ]);
  useEffect(() => {
    setSortBy((prev) => ({ ...prev, field: "_id", order: "asc" }));
    setPageSize(10);
    setPage(1);
    setSearch("");
    setStatusFilter("");
    setAllChecked(false);
    setCheckedItems([]);

    fetchData();
  }, [masterId]);

  return (
    <>
      <div className="">
        <div className="container ">
          <div className="d-flex justify-content-between align-items-center">
            <div className="show-breadcrumb pt-3">
              <div className="">
                <h5 className="text-capitalize">{masterNamePlural}</h5>
              </div>
              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a className="">Configure </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a className="">{parameterName}</a>
                  </li>
                  <li
                    className="breadcrumb-item active text-capitalize"
                    aria-current="page"
                  >
                    {masterNamePlural}
                  </li>
                </ol>
              </nav>
            </div>

            {/* <div>
              <button
                type="button"
                id="openPopup"
                className="btn-bg text-capitalize"
                onClick={() => {
                  downloadExcel()
                }}
              >
                <span className="plus-icon ">
                  <img src={plus1} alt="Plus Icon" />
                </span>{" "}
                BULK UPLOAD
              </button>
            </div> */}
          </div>

          <div
            className="navbar-3 d-flex justify-content-between"
            style={{ marginTop: "-3px" }}
          >
            <div className="d-flex gap-3">
              <div className="search-container ">
                <img src={search2} alt="Search" />
                <input
                  type="text"
                  className=""
                  id="search"
                  value={search}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                  placeholder="Search "
                  name="search"
                  autoComplete="off"
                />
              </div>
              <div>
                {hasPermission(["parameters.delete"]) &&
                  checkedItems.length > 0 && (
                    <button
                      id="bulkDelete"
                      className="bulkDelete-btn"
                      style={{ display: "block" }}
                      onClick={() => setBulkDeleteModal(true)}
                    >
                      <span>
                        <img
                          src={recyclebin}
                          height="24px"
                          width="24px"
                          alt=""
                        />
                      </span>{" "}
                      Inactive
                    </button>
                  )}
              </div>
            </div>

            <div className="d-flex gap-3">
              {" "}
              <div className="dropdown">
                <select
                  id="cars"
                  className=" select-unit textarea "
                  value={statusFilter}
                  onChange={(e) => handleStatusChange(e.target.value)}
                  style={{
                    width: "120px",
                    height: "calc(100% - 1px)",
                    // Adjust height to be 3px less
                  }}
                >
                  <option value="">All </option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              {hasPermission(["parameters.create"]) && (
                <div>
                  <button
                    type="button"
                    id="openPopup"
                    className="btn-bg text-capitalize"
                    onClick={() => {
                      // setErrors({});
                      handleOpenuploadModal(true);
                    }}
                  >
                    {/* <span className="plus-icon ">
                    <img src={plus1} alt="Plus Icon" />
                  </span>{" "} */}
                    Bulk Upload
                    {/* {masterNameSingular} */}
                  </button>
                </div>
              )}
              {hasPermission(["parameters.create"]) && (
                <div>
                  <button
                    type="button"
                    id="openPopup"
                    className="btn-bg text-capitalize"
                    onClick={() => {
                      setErrors({});
                      handleOpenAddModal(true);
                    }}
                  >
                    <span className="plus-icon ">
                      <img src={plus1} alt="Plus Icon" />
                    </span>{" "}
                    Add New {masterNameSingular}
                  </button>
                </div>
              )}
            </div>
          </div>

          <div style={{ marginTop: "-10px" }}>
            <div className="table-responsive">
              <table className="table align-middle table-text">
                <thead className="table-head align-middle">
                  <tr>
                    <th className="table-check">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={handleHeaderCheckboxChange}
                      />
                    </th>
                    <th>ID</th>
                    {columnValue.map((field, index) => (
                      <th
                        className="col text-uppercase"
                        key={index}
                        onClick={() => handleSortChange(field.field_name)}
                      >
                        <span>
                          {field.display_name}{" "}
                          {sortBy.field === field.field_name && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="Ascending" />
                              ) : (
                                <img src={ArrowDown} alt="Descending" />
                              )}
                            </span>
                          )}
                        </span>
                      </th>
                    ))}
                    <th className="col text-uppercase">Status</th>
                    {(hasPermission(["parameters.update"]) ||
                      hasPermission(["parameters.delete"])) && (
                        <th className="col-2 text-uppercase">Action</th>
                      )}
                  </tr>
                </thead>
                <tbody className="pl-4">
                  {columnData.map((item, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={item.status ? "" : "disabled text-muted"}
                    >
                      <td className="table-check">
                        <input
                          type="checkbox"
                          checked={checkedItems.includes(item._id)}
                          onChange={() => handleRowCheckboxChange(item._id)}
                          disabled={!item.status}
                        />
                      </td>
                      <td>{rowIndex + startIndex}</td>
                      {columnValue.map((field, cellIndex) => (
                        <td key={cellIndex}>{item[field.field_name]}</td>
                      ))}
                      <td className="col">
                        {item.status ? (
                          <span className="active-status">Active</span>
                        ) : (
                          <span className="inactive">Inactive</span>
                        )}
                      </td>
                      {(hasPermission(["parameters.update"]) ||
                        hasPermission(["parameters.delete"])) && (
                          <td className="col">
                            {item.status &&
                              hasPermission(["parameters.update"]) && (
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  className="align-content-center me-3"
                                  onClick={() => handleOpenEditModal(item)}
                                  disabled={!item.status}
                                >
                                  <img src={edit} alt="edit" />
                                </button>
                              )}
                            {hasPermission(["parameters.delete"]) && (
                              <span className="align-content-center switcher">
                                <label className="switch switch1">
                                  <input
                                    type="checkbox"
                                    checked={item.status}
                                    onChange={() =>
                                      handleToggleUserStatus(
                                        item._id,
                                        item.status
                                      )
                                    }
                                  />
                                  <span className="slider slider1 round"></span>
                                </label>
                              </span>
                            )}
                          </td>
                        )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              pageSize={pageSize}
              onPageSizeChange={handlePageSizeChange}
              totalItems={totalItems}
              startIndex={startIndex}
              endIndex={endIndex}
            />
          </div>
        </div>

        {/* Add Modal */}

        {master && (
          <div
            id="overlay"
            className={`modal fade ${showAddModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showAddModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Add Data</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={handleCloseAddModal}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className="addunit-form">
                    <div className="row">
                      <div className="d-flex flex-column">
                        {master.masterFields.map((masterField) => (
                          <div key={masterField._id}>
                            <div className="row">
                              <div className="col">
                                <div className="d-flex flex-column mb-4">
                                  <label className="addunit-form-text">
                                    {masterField.display_name}
                                    {masterField.required && (
                                      <span className="text-danger"> *</span>
                                    )}
                                  </label>
                                  {masterField.field_type.toLowerCase() ===
                                    "boolean" ? (
                                    <select
                                      className="form-control"
                                      name={masterField.field_name}
                                      value={
                                        formData[masterField.field_name] || ""
                                      }
                                      onChange={handleInputChange}
                                      onFocus={() =>
                                        setFocusedField(masterField.field_name)
                                      }
                                      onBlur={() => setFocusedField(null)}
                                    >
                                      <option value="true">True</option>
                                      <option value="false">False</option>
                                    </select>
                                  ) : (
                                    <input
                                      name={masterField.field_name}
                                      type={masterField.field_type.toLowerCase()}
                                      value={
                                        formData[masterField.field_name] || ""
                                      }
                                      onChange={handleInputChange}
                                      onFocus={() =>
                                        setFocusedField(masterField.field_name)
                                      }
                                      onBlur={() => setFocusedField(null)}
                                      className={`form-control ${errors[masterField.field_name]
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      placeholder={`Enter ${masterField.display_name}`}
                                    />
                                  )}
                                  {focusedField === masterField.field_name &&
                                    masterField.tooltip && (
                                      // <small
                                      //   className="pt-2 mx-2"
                                      //   style={{ color: "grey" }}
                                      // >
                                      //   {masterField.tooltip}
                                      // </small>
                                      <small
                                        style={{
                                          position: "relative",
                                          display: "inline-block",
                                          backgroundColor: "#DCDCDC",
                                          color: "#202020",
                                          padding: "6px 12px",
                                          borderRadius: "4px",
                                          fontSize: "12px",
                                          whiteSpace: "normal", // Allow wrapping
                                          margin: "10px 0",
                                          textAlign: "center",
                                          maxWidth: "100%", // Prevent from taking up too much width
                                          wordWrap: "break-word", // Ensure long words wrap correctly
                                        }}
                                      >
                                        {masterField.tooltip}
                                        <span
                                          style={{
                                            position: "absolute",
                                            bottom: "100%",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            marginBottom: "1px",
                                            width: "0",
                                            height: "0",
                                            borderLeft: "5px solid transparent",
                                            borderRight:
                                              "5px solid transparent",
                                            borderBottom: "5px solid #DCDCDC",
                                          }}
                                        ></span>
                                      </small>
                                    )}
                                  {errors[masterField.field_name] && (
                                    <div className="invalid-feedback">
                                      {errors[masterField.field_name]}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={handleCloseAddModal}
                    >
                      Close
                    </button>
                    <button type="submit" id="openPopup" className="update-btn">
                      Add
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}

        {/* Edit Modal */}

        {master && (
          <div
            id="overlay"
            className={`modal fade ${showEditModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showEditModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div className="addunit-card Width 25%">
                <form onSubmit={handleEditSubmit}>
                  <div className="addunit-header">
                    <h4>Edit Data</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={handleCloseEditModal}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>

                  <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <div className="addunit-form">
                      <div className="row pt-3">
                        <div className="col">
                          <div className="d-flex flex-column">
                            <div>
                              {master.masterFields.map((masterField) => (
                                <div key={masterField._id}>
                                  <div className="row">
                                    <div className="col">
                                      <div className="d-flex flex-column mb-4">
                                        <label className="addunit-form-text">
                                          {masterField.display_name}
                                          {masterField.required && (
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          )}
                                        </label>
                                        {masterField.field_type.toLowerCase() ===
                                          "boolean" ? (
                                          <select
                                            className="form-control"
                                            name={masterField.field_name}
                                            onChange={handleEditInputChange}
                                            onFocus={() =>
                                              setFocusedEditField(
                                                masterField.field_name
                                              )
                                            }
                                            onBlur={() =>
                                              setFocusedEditField(null)
                                            }
                                            value={
                                              formData[
                                              masterField.field_name
                                              ] || ""
                                            }
                                          >
                                            <option value="true">True</option>
                                            <option value="false">False</option>
                                          </select>
                                        ) : (
                                          <input
                                            name={masterField.field_name}
                                            type={masterField.field_type.toLowerCase()}
                                            onChange={handleEditInputChange}
                                            onFocus={() =>
                                              setFocusedEditField(
                                                masterField.field_name
                                              )
                                            }
                                            onBlur={() =>
                                              setFocusedEditField(null)
                                            }
                                            value={
                                              formData[
                                              masterField.field_name
                                              ] || ""
                                            }
                                            className={`form-control ${errors[masterField.field_name]
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            placeholder={`Enter ${masterField.display_name}`}
                                          />
                                        )}
                                        {focusedEditField ===
                                          masterField.field_name &&
                                          masterField.tooltip && (
                                            // <small
                                            //   className="pt-2 mx-2"
                                            //   style={{ color: "grey" }}
                                            // >
                                            //   {masterField.tooltip}
                                            // </small>
                                            <small
                                              style={{
                                                position: "relative",
                                                display: "inline-block",
                                                backgroundColor: "#DCDCDC",
                                                color: "#202020",
                                                padding: "6px 12px",
                                                borderRadius: "4px",
                                                fontSize: "12px",
                                                whiteSpace: "normal", // Allow wrapping
                                                margin: "10px 0",
                                                textAlign: "center",
                                                maxWidth: "100%", // Prevent from taking up too much width
                                                wordWrap: "break-word", // Ensure long words wrap correctly
                                              }}
                                            >
                                              {masterField.tooltip}
                                              <span
                                                style={{
                                                  position: "absolute",
                                                  bottom: "100%",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  marginBottom: "1px",
                                                  width: "0",
                                                  height: "0",
                                                  borderLeft:
                                                    "5px solid transparent",
                                                  borderRight:
                                                    "5px solid transparent",
                                                  borderBottom:
                                                    "5px solid #DCDCDC",
                                                }}
                                              ></span>
                                            </small>
                                          )}
                                        {errors[masterField.field_name] && (
                                          <div className="invalid-feedback">
                                            {errors[masterField.field_name]}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={handleCloseEditModal}
                    >
                      Close
                    </button>
                    <button type="submit" id="openPopup" className="update-btn">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        )}

        {/* Upload Modal */}

        {master && (
          <div
            id="overlay"
            className={`modal fade ${showUploadModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showUploadModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div className="addunit-card Width 25%">
                {showPreviewModal ? (
                  // Excel Preview Modal
                  // <div className="addunit-card" style={{ width: "700px", height: "500px" }}>
                  //   <div className="addunit-header">
                  //     <h4>Excel Data Preview</h4>
                  //     <button
                  //       style={{ border: "none", backgroundColor: "inherit" }}
                  //       type="button"
                  //       className="close"
                  //       onClick={() => setShowPreviewModal(false)}
                  //     >
                  //       <img src={close} width="28px" height="28px" alt="Close" />
                  //     </button>
                  //   </div>
                  //   <div className="addunit-form">
                  //     <table className="table table-bordered">
                  //       <thead>
                  //         <tr>
                  //           {excelData[0]?.map((header, index) => (
                  //             <th key={index}>{header}</th>
                  //           ))}
                  //         </tr>
                  //       </thead>
                  //       <tbody>
                  //         {excelData.slice(1).map((row, rowIndex) => (
                  //           <tr key={rowIndex}>
                  //             {row.map((cell, cellIndex) => (
                  //               <td key={cellIndex}>{cell}</td>
                  //             ))}
                  //           </tr>
                  //         ))}
                  //       </tbody>
                  //     </table>
                  //   </div>

                  //   <div className="addunit-card-footer justify-content-between">
                  //     <button
                  //       type="button"
                  //       className="discard-btn"
                  //       onClick={() => setShowPreviewModal(false)}
                  //     >
                  //       Discard
                  //     </button>
                  //     <button type="button" className="update-btn" onClick={uploadExcel}>
                  //       Submit
                  //     </button>
                  //   </div>
                  // </div>
                  <div className="addunit-card" style={{ width: "700px", height: "500px" }}>
                    <div className="addunit-header">
                      <h4>Excel Data Preview</h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={() => setShowPreviewModal(false)}
                      >
                        <img src={close} width="28px" height="28px" alt="Close" />
                      </button>
                    </div>
                    <div
                      className="addunit-form"
                      style={{ overflowY: "auto", maxHeight: "400px" }} // Add scrolling behavior here
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {excelData[0]?.map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {excelData.slice(1).map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="addunit-card-footer justify-content-between">
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => setShowPreviewModal(false)}
                      >
                        Discard
                      </button>
                      <button type="button" className="update-btn" onClick={uploadExcel}>
                        Submit
                      </button>
                    </div>
                  </div>

                ) : (
                  // Bulk Add Data Modal
                  <>
                    <div className="addunit-header">
                      <h4>Bulk Add Data</h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={handleCloseUploadModal}
                      >
                        <img src={close} width="28px" height="28px" alt="Close" />
                      </button>
                    </div>

                    <form autoComplete="off">
                      <div className="addunit-form">
                        <div className="mb-5">
                          <div className="d-flex justify-content-between">
                            <p className="addunit-form-text">{/* Bulk Upload */}</p>
                            <div className="d-flex justify-content-between">
                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "transparent",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="align-content-center me-3 mt-1"
                                onClick={downloadExcel}
                              >
                                <p className="addunit-form-text mt-3 mb-3">Download Template</p>
                                <img
                                  style={{ width: "25px", marginLeft: "8px" }}
                                  src={lucide_download}
                                  alt="Download"
                                />
                              </button>
                            </div>
                          </div>

                          <div>
                            <label className="file" style={{ height: "50px" }}>
                              <input
                                type="file"
                                id="fileInput"
                                aria-label="File browser example"
                                onChange={handleFileChange}
                              />
                              <span className="file-custom" id="fileName">
                                {selectedFile ? selectedFile.name : "No file chosen"}
                              </span>
                            </label>
                            <p
                              style={{
                                color: "#dc3545",
                                width: "450px",
                                paddingLeft: "10px",
                                marginTop: "10px",
                              }}
                              className="mt-0"
                            >
                              {errorForUpload}
                            </p>
                            <p
                              className="mx-2 mt-0"
                              style={{
                                fontSize: "15px",
                                color: "gray",
                                paddingBottom: "0px",
                              }}
                            >
                              Upload format can be XLS or CSV file
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="addunit-card-footer justify-content-between">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={handleCloseUploadModal}
                        >
                          Close
                        </button>
                        <button
                          id="openPopup"
                          className="update-btn"
                          type="button"
                          onClick={previewExcel}
                        >
                          Preview
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </div>


            )}
          </div>
        )}

        {/*Conformation Modal */}
        {master && (
          <div
            id="overlay"
            className={`modal fade ${confirmModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: confirmModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>
                      {actionType === "Restore" ? "Restore" : "Inactive"} Master
                      Field
                    </h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>
                      Are you sure you want to{" "}
                      {actionType === "Restore" ? "restore" : "inactive"} this
                      master field data?
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      {actionType === "Restore" ? "Restore" : "Inactive"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Bulk Delete Modal */}
        {master && (
          <div
            id="overlay"
            className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: bulkDeleteModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Bulk Inactive</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="bulk-delete-unit">
                    <img src={recyclebin} width="48px" height="48px" />

                    <h4 className="delete-unit-h4">Inactive {masterName}</h4>
                    <p className="delete-unit-text">
                      Are you sure you want to inactive all the selected{" "}
                      <span className="text-lowercase">{masterName}?</span>
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      CANCEL
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={handleBulkDelete}
                    >
                      CONFIRM
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default DynamicTable1;
